module.exports = __webpack_public_path__ + "static/media/askelie-transparent-logo-front.2c414dca.png";